import Model from "../Model";

class ZonesByDivision extends Model{

    buildUrl ({ param }) {
        return ['divisionview/getzonesbydivisionid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new ZonesByDivision;